import { useState, useContext } from "react";
import { RiCloseFill } from "react-icons/ri"
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import ApiContext from "src/provider/API/call-service";
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, SidePopupContainer, Switch } from "src/style"
import helpers from "src/utils/helpers";
import { useTranslation } from "react-i18next";


export const CreateInstitution: React.FC<any> = ({getInstitutions, close}) => {
    const {notifier} = useContext(VisibilityContext)
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({
        institutionName: '', firstName: '', lastName: '', username: '',
        email: '', phoneNumber: '', institutionCode: '', alias: '',
        isBaasInstitution: false
    })
    const {t} = useTranslation()

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (!helpers.validatePhoneNoAll(input.phoneNumber)) return notifier.show(t('createInstitution.validation.phone'), "Validation Response")
        if (!helpers.validateEmail(input.email)) return notifier.show(t('createInstitution.validation.email'), "Validation Response")

        const response = await API.createInstitutionAndAdmin({...input, role: 'Admin'})
        if (response) {
            if (getInstitutions) getInstitutions()
            close()
        }    
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="new-ads-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <AbsoluteContainer top='1.5' right='1.5'>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </AbsoluteContainer>
                <AppText color='#101828' textSize="1.8" fontWeight="700" fontFamily="Gilmer-Bold">
                    {t('createInstitution.title')}
                </AppText>
                <Form onSubmit={handleSubmit}>
                    <CustomContainer topMargin='2'>
                        <AppSpan textSize="1.6" fontWeight="600" fontFamily="Gilmer-Bold">{t('createInstitution.sections.institutionDetails')}</AppSpan>
                        <FormGroup topMargin='1.5'>
                            <label> {t('createInstitution.institutionName.label')}</label>
                            <input 
                                placeholder={t('createInstitution.institutionName.placeholder')} 
                                name='institutionName'
                                value={input.institutionName}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>{t('createInstitution.institutionCode.label')}</label>
                            <input 
                                placeholder={t('createInstitution.institutionCode.placeholder')} 
                                name='institutionCode'
                                value={input.institutionCode}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>  
                        <FormGroup>
                            <label>{t('createInstitution.institutionAlias.label')}</label>
                            <input 
                                placeholder={t('createInstitution.institutionAlias.placeholder')}
                                name='alias'
                                value={input.alias}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup> 
                        <FlexRow gap="1.5" alignItems="flex-start" justifyContent="flex-start" bottomMargin="2">
                            <AppSpan fontWeight="600" color="#344054">{t('createInstitution.baasInstitution.label')}</AppSpan>
                            <Switch
                                radius='1.17' bgColor='#E7E7E7' 
                                checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                            >
                                <input 
                                    type="checkbox" 
                                    checked={input.isBaasInstitution}
                                    onChange={(e) => setInput({...input, isBaasInstitution: e.target.checked})} 
                                />
                                <div ></div>
                                <span></span>
                            </Switch>
                        </FlexRow>  
                    </CustomContainer>
                    <CustomContainer topMargin="1">
                        <AppSpan textSize="1.6" fontWeight="600" fontFamily="Gilmer-Bold">{t('createInstitution.sections.adminDetails')}</AppSpan>
                        <FormGroup topMargin="1.5">
                            <label>{t('createInstitution.firstName.label')}</label>
                            <input 
                                placeholder={t('createInstitution.firstName.placeholder')}
                                name='firstName'
                                value={input.firstName}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>  
                        <FormGroup>
                            <label>{t('createInstitution.lastName.label')}</label>
                            <input 
                                placeholder={t('createInstitution.lastName.placeholder')}
                                name='lastName'
                                value={input.lastName}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>  
                        <FormGroup>
                            <label>{t('createInstitution.username.label')}</label>
                            <input 
                                placeholder={t('createInstitution.username.placeholder')}
                                name='username'
                                value={input.username}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>  
                        <FormGroup>
                            <label>{t('createInstitution.email.label')}</label>
                            <input 
                                placeholder={t('createInstitution.email.placeholder')}
                                name='email'
                                type='email'
                                value={input.email}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>  
                        <FormGroup>
                            <label>{t('createInstitution.phoneNumber.label')}</label>
                            <input 
                                placeholder={t('createInstitution.phoneNumber.placeholder')}
                                name='phoneNumber'
                                type='number'
                                value={input.phoneNumber}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>  
                    </CustomContainer>
                    
                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='8.1'
                            titleSize='1.4' fontWeight='600'
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                           {t('createInstitution.button.submit')}
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}